import { Injectable } from '@angular/core';

// Ancien import du tuto qui ne marche plus
// import * as firebase from 'firebase';
// !! Du coup ne pas oublier d'impoter les autres modules comme auth et firestore!!
import firebase from 'firebase/app';

import 'firebase/database';
import 'firebase/storage';
import { Subject } from 'rxjs';
import { Book } from '../models/Book.model';
// import "firebase/firestore";

import 'firebase/auth';


@Injectable({
  providedIn: 'root'
})

export class BooksService {

  userUID!: string;

  books: Book[] = [];

  booksSubject = new Subject<Book[]>();

  constructor() {
    
    // console.log('Salut Book Service');
    
    // Vérification des données de l'utilisateur
    firebase.auth().onAuthStateChanged(
      // Si l'utilisateur est authentifié, user existera
      (user) => {
        if (user) {
          // console.log('Book Service - Utilisateur : ', user.uid);
          this.userUID = user.uid
        } else {
          // console.log('Book Service - Pas d\'utilisateur');
        }
      }
    )
   }

  emitBooks() {
    this.booksSubject.next(this.books);
  }

  saveBooks() {
    firebase.database().ref('/books/' + this.userUID).set(this.books);
  }

  getBooks() {
    firebase.database().ref('/books/' + this.userUID)
      .on('value', (data) => {
        // On vérifie que data.val() existe avec l'opérateur ternaire
        this.books = data.val() ? data.val() : [];
        this.emitBooks();
      })
  }

  getSingleBook(id: number) {
    // Ajouté <Book> à Promise car sinon erreur de type dans single book component
    return new Promise<Book>(
      (resolve, reject) => {
        firebase.database().ref('/books/' + this.userUID + '/' + id).once('value').then(
          (data) => {
            resolve(data.val());
          },
          (error) => {
            reject(error);
          }
        )
      }
    )
  }

  createNewBook(newBook: Book) {
    this.books.push(newBook);
    this.saveBooks();
    this.emitBooks();
  }

  removeBook(book: Book) {
    // On vérifie qu'une photo existe, puis on la supprime du storage
    if(book.photo) {
      const storageRef = firebase.storage().refFromURL(book.photo);
      storageRef.delete().then(
        () => {
          // console.log('Photo supprimée');
        },
        (error) => console.log('Problème de suppression de la photo : ' + error) 
      )
      // Lui met un catch après le then, mais ça revient au même que de mettre l'erreur dans le then directement, ce qu'il a fait depuis le début. Je sais pas pourquoi il utilise catch soudainement 
      // .catch(
      //   (error) => console.log('Problème de suppression de la photo : ' + error)
      // )
    }

    // Il cherche l'index du book à enlever puis l'enlève l'array des books.
    // Ce serait pas plus simple avec un simple filter?
    const bookIndexToRemove = this.books.findIndex(
      // Ici il me met un warning que je ne comprend pas, et ses seules solutions sont de choisir entre une fonction anonyme et une fléchée. Dans les 2 cas ce warning reste, donc rien à rien.
      // Solution, ajouter else return false.
      (bookEl) => {
        if (bookEl === book) {
          return true;
        } else return false;
      }
    );
    // Il enlève le book trouvé de l'array des books
    this.books.splice(bookIndexToRemove, 1);
    // Le fait d'appeler saveBooks ici va prendre les données locales et les envoyer sur le serveur. C'est donc pas comme un retrait direct du serveur, mais ça marche aussi.
    this.saveBooks();
    this.emitBooks();
  }

  uploadFile(file: File) {
    // Ici ajout <string> à Promise sinon erreur
    return new Promise<string>(
      (resolve, reject) => {
        // On créé un id quasi unique avec Date, donc c'est à la millisecondes près
        const almostUniqueFileName = Date.now().toString();
        const upload = firebase.storage().ref()
        // On prend l'id et on ajoute le nom du fichier original, comme ça on garde aussi la bonne extension
          .child('images/' + this.userUID + '/' + almostUniqueFileName + file.name)
          .put(file);
        // Une syntaxe peu intuitive mais qui permet simplement de surveiller le changement d'état de l'upload 
        upload.on(firebase.storage.TaskEvent.STATE_CHANGED,
          () => {
            // console.log('Chargement en cours...');
          },
          (error) => {
            console.log('Erreur de chargement : ' + error);
            reject();
          },
          () => {
            // console.log('Chargement terminé...');
            // Syntaxe downloadURL dépréciée
            // resolve(upload.snapshot.downloadURL)
            resolve(upload.snapshot.ref.getDownloadURL());
          }
        )
      }
    );
  };


}
